import { ChevronLeft, ChevronRight } from 'lucide-react';
import { copy } from '../lib/copy';

type CursorPaginationProps = {
  pageNumber: number;
  itemCount: number;
  canPrev: boolean;
  hasNext: boolean;
  loading?: boolean;
  onPrev: () => void;
  onNext: () => void;
};

export function CursorPagination({
  pageNumber,
  itemCount,
  canPrev,
  hasNext,
  loading = false,
  onPrev,
  onNext,
}: CursorPaginationProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-ops-border px-4 py-3">
      <p className="text-sm text-ops-muted">
        {copy.pagination.page(pageNumber)}
        {itemCount > 0 ? ` · ${copy.pagination.items(itemCount)}` : ''}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          className="ops-btn-secondary py-2 text-sm"
          disabled={!canPrev || loading}
          onClick={onPrev}
        >
          <ChevronLeft className="h-4 w-4" />
          {copy.common.previous}
        </button>
        <button
          type="button"
          className="ops-btn-secondary py-2 text-sm"
          disabled={!hasNext || loading}
          onClick={onNext}
        >
          {copy.common.next}
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
